import React from 'react';
import { Link } from 'react-router-dom';

const CompoundSideListAddButton = ({ path, title, hasPermission, onAdd }) => (
  <Link
    to={path}
    className="ant-btn ant-btn-primary"
    style={{ width: '100%' }}
    onClick={() => onAdd()}
    disabled={!hasPermission}
  >
    {title}
  </Link>
);

export default CompoundSideListAddButton;
